// extracted by mini-css-extract-plugin
export default {"hint":"JeddleFreeTextQuestion__hint___w0iv8","actions":"JeddleFreeTextQuestion__actions___x2gnV"};